import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import GameShow from './components/GameShow';
import Leaderboard from './components/Leaderboard';
import AdminPanel from './components/AdminPanel';
import Success from './components/Success';
import Cancel from './components/Cancel';
import Header from './components/Header';
import Footer from './components/Footer';
import Register from './pages/Register';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerification from './pages/EmailVerification';
import GenerateQuestion from './pages/GenerateQuestion';
import ManageUsers from './pages/CreateGameShowUser';
import QueCards from './pages/QueCards';
import Gameshow from './pages/Gameshow';
import Contact from './pages/Contact';
import Support from './pages/Support';
import Feedback from './pages/Feedback';
import HowItWorks from './pages/HowItWorks';
import LiveStream from './pages/LiveStream';
import MyAnswer from './pages/MyAnswer';
import Profile from './pages/Profile';
import PaymentForm from './components/PaymentForm';
import { ProtectedRoute, AdminRoute, RegularUserRoute } from './components/ProtectedRoute';
import PersistentVideoPlayer from './components/PersistentVideoPlayer';
import { getCurrentUser } from './utils/api';
import './App.css';

// Initialize Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_replace_with_your_actual_stripe_publishable_key');

function App() {
  const user = getCurrentUser();
  const isAdmin = user?.role_id === 1;
  
  return (
    <Elements stripe={stripePromise}>
      <Router>
        <div className={`App ${isAdmin ? 'has-sidebar' : ''}`}>
          <Header />
          <main className="main-content">
            <Routes>
              {/* Public routes */}
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/verify-email" element={<EmailVerification />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/live-stream" element={<LiveStream />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/support" element={<Support />} />
              <Route path="/feedback" element={<Feedback />} />
              
              {/* Protected routes (require authentication) - accessible to ALL authenticated users including game show users */}
              <Route path="/" element={
                <ProtectedRoute>
                  <GameShow />
                </ProtectedRoute>
              } />
              <Route path="/my-answer" element={
                <ProtectedRoute>
                  <MyAnswer />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
              
              {/* Regular user routes (accessible to admin and regular users, NOT game show users) */}
              <Route path="/leaderboard" element={
                <RegularUserRoute>
                  <Leaderboard />
                </RegularUserRoute>
              } />
              <Route path="/payment" element={
                <RegularUserRoute>
                  <PaymentForm />
                </RegularUserRoute>
              } />
              <Route path="/success" element={
                <RegularUserRoute>
                  <Success />
                </RegularUserRoute>
              } />
              <Route path="/cancel" element={
                <RegularUserRoute>
                  <Cancel />
                </RegularUserRoute>
              } />
              
              {/* Admin-only routes */}
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              } />
              <Route path="/que-cards" element={
                <AdminRoute>
                  <QueCards />
                </AdminRoute>
              } />
              <Route path="/gameshow" element={
                <AdminRoute>
                  <Gameshow />
                </AdminRoute>
              } />
              <Route path="/generate-question" element={
                <AdminRoute>
                  <GenerateQuestion />
                </AdminRoute>
              } />
              <Route path="/manage-users" element={
                <AdminRoute>
                  <ManageUsers />
                </AdminRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <PersistentVideoPlayer />
        </div>
      </Router>
    </Elements>
  );
}

export default App; 